import { useEffect } from "react";

/**
 * Sets the browser tab title AND swaps the favicon while an SMRU partner page
 * is mounted, restoring both on unmount — so the AI.Prof × SMRU collaboration
 * shows up in the tab/link, not just the page body.
 */
export function usePartnerTab(title, favicon = "/partners/smru/smrulogo.png") {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;

        let link = document.querySelector("link[rel='icon']");
        const createdLink = !link;
        const prevHref = link ? link.getAttribute("href") : null;
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }
        link.setAttribute("href", favicon);

        return () => {
            document.title = prevTitle;
            if (createdLink) {
                link.remove();
            } else if (prevHref) {
                link.setAttribute("href", prevHref);
            }
        };
    }, [title, favicon]);
}
